export default function SelectCollection(state, payload){
  const {collection} = payload;
  state.selectedCollections[collection.id] = collection;
  return {...state}
}